<template>
  <div style="width: 100%;background-color: lightblue;overflow: hidden;overflow-y: hidden; overflow-x: hidden;">
    <img   id="IDGuideImg" :src="selectedImgSrc" class="guideImg"
           style="
           height: 100vh;
           width: 100vw;
           z-index: 100"  @click="guide_next">
    <input id="BTSkip" type="button" class="guideButtons" @click="guide_skip"  value="Skip"/>
  </div>
</template>

<script>

  export default {
    name: "GuidePage",
    data(){
      return {
        guidePages:[
          "http://bunjs.aiside.top/page-1-1.jpg",
          "http://bunjs.aiside.top/page-1-2.jpg",
          "http://bunjs.aiside.top/page-1-3.jpg",
          "http://bunjs.aiside.top/page-1-4.jpg",
          "http://bunjs.aiside.top/page-1-5.jpg",
          "http://bunjs.aiside.top/page-1-6.jpg",
          "http://bunjs.aiside.top/page-1-7.jpg",
        ],
        currentIndex:0,
        selectedImgSrc:undefined,
        guideImgSize:{width:1440, height:720},
        guideButtonPositionX_NEXT:[1161,678,737,1050,709,901,2335],//Next
        guideButtonPositionX_SKIP:[1217,734,793,1105,765,957,1326],//Skip
        guideButtonPositionY:[178,178,628,565,166,630,169],
      }
    },
    created() {

    },
    mounted() {
      this.updateNext();
      localStorage.setItem("ls_guide","1");
    },
    methods:{
      updateNext(){
        if(this.currentIndex==7){
          this.$router.push({path:'/BNUMap/Main/Introduction'});
          return;
        }
        this.selectedImgSrc = this.guidePages[this.currentIndex];
      },
      guide_next(){
        this.currentIndex ++;
        this.updateNext();
      },
      guide_skip(){
        this.$router.push({path:'/BNUMap/Main/Introduction'});
      },
    }
  }
</script>

<style scoped>
  .guideButtons{
    width: 100px;
    height: 50px;
    position: absolute;
    right: 0px;
    bottom: 0px;
    background-color: transparent;
    border: solid 1px transparent;
    color: white;
    z-index: 101;
    font-size: 4em;
  }
</style>



// WEBPACK FOOTER //
// src/view/BSD/GuidePage.vue